module.exports = __webpack_public_path__ + "img/2025-06-11b_4.25e6ec0f.jpg";